import React, {Component} from 'react';
import '@progress/kendo-theme-default/dist/all.css';
// import './App.css';

import categories from '../sheltercat.json';

import { process } from '@progress/kendo-data-query';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Window } from '@progress/kendo-react-dialogs';
import shelter from '../shelter.json';
import Cards from '../components/Cards.jsx';

class Petgrid extends Component {

  state = {
    dropdownlistCategory: null,
    gridDataState: {
      sort: [
        { field: "ProductName", dir: "asc" }
      ],
      skip: 0,
      take: 10
    },
    windowvisible: false,
    gridClickedRow: {}
  }

   handleGridRowClick = (e) => {
    this.setState({
        windowvisible: true,
        gridClickedRow: e.dataItem
    });
  }
  closeWindow = (e) => {
    this.setState({
        windowvisible: false
    });
   }

  handleDropDownChange = (e) => {
    let newDataState = { ...this.state.gridDataState };
    console.log('ok');
    if (e.target.value.CategoryID !== null) {
      newDataState.filter = {
        logic: 'and',
        filters: [{ field: 'post', operator: 'eq', value: e.target.value.post }]
      }
      newDataState.skip = 0
    } else {
      newDataState.filter = []
      newDataState.skip = 0
    }
    this.setState({
      dropdownlistCategory: e.target.value.CategoryID,
      gridDataState: newDataState
    });
  }

  handleGridDataStateChange = (e) => {
    this.setState({gridDataState: e.dataState});
  }

  render() {
    return (
      <div className="card-container ">
        <h1></h1>
        <p>
          <DropDownList
            data={categories}
            dataItemKey="CategoryID"
            textField="CategoryName"
            defaultItem={{CategoryID: null, CategoryName: "select location"}}
            onChange={this.handleDropDownChange}
            />
          &nbsp;  <strong>{null}</strong>
        </p>
          <h2>SHELTERS</h2>
        <Grid
          data={process(shelter, this.state.gridDataState)}
          pageable={true}
          sortable={true}
          {...this.state.gridDataState}
          onDataStateChange={this.handleGridDataStateChange}
          onRowClick={this.handleGridRowClick}
          style={{ height: "400px" }}>
          <GridColumn field="org_name" title="Shelter Name" />
          <GridColumn field="org_phone" title="Phone"  />
          <GridColumn field="org_email" title="Email"  />
          {/* <GridColumn field="animals_photos1"  title="photo" /> */}
          <GridColumn field="city" title="City" />
          <GridColumn field="post" title="postcode" />
         
        
        </Grid>
        {this.state.windowvisible &&
          <Window
            title="Shelter Details"
            onClose={this.closeWindow}
            height={350}>
            <dl style={{textAlign:"left"}}>
              <dt> Name</dt>
              <dd>{this.state.gridClickedRow.org_name}</dd>
              <dt>contact </dt>
              <dd>{this.state.gridClickedRow.org_email}</dd>
              <dt>phone</dt>
              <dd>{this.state.gridClickedRow.org_phone} </dd>
            </dl>
            
          </Window>
        } 
      </div>
    );
  }
}

class checkboxColumn extends Component {
  render() {
    return (
        <td>
          <input type="checkbox" checked={this.props.dataItem[this.props.field]} disabled="disabled" />
        </td>
    );
  }
}

export default Petgrid;